var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drfSmgSetting" },
    [
      _c(
        "el-form",
        {
          ref: "drfSmgChildForm",
          staticClass: "form",
          attrs: {
            model: _vm.value,
            inline: true,
            disabled: !_vm.edit,
            "label-suffix": ":",
            "label-width": "9rem",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "item_set" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "温馨提示信息方式",
                    prop: "drf_smg_rule_type",
                    rules: [
                      { required: true, trigger: "change", message: "请选择" },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "28rem" },
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeType },
                      model: {
                        value: _vm.value.drf_smg_rule_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "drf_smg_rule_type", $$v)
                        },
                        expression: "value.drf_smg_rule_type",
                      },
                    },
                    _vm._l(_vm.list, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item_set" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "温馨提示信息",
                    prop: "drf_smg_tip_content",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "温馨提示信息不可为空",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "28rem" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入内容",
                      "show-word-limit": "",
                      disabled: !_vm.edit || _vm.value.drf_smg_rule_type === 0,
                      rows: 6,
                      maxlength: 300,
                    },
                    model: {
                      value: _vm.value.drf_smg_tip_content,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "drf_smg_tip_content", $$v)
                      },
                      expression: "value.drf_smg_tip_content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "位置示例图" } },
                [
                  _c("el-image", {
                    style: _vm.imgStyle,
                    attrs: {
                      "z-index": 3000,
                      src: _vm.imgSrc,
                      "preview-src-list": [_vm.imgSrc],
                      fit: "scale-down",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }